import $ from 'jquery';
import simpleLightbox from 'simplelightbox';

$(function(){
        var lightbox = $('.slide a').simpleLightbox();

        lightbox.on('show.simplelightbox', function(){

        });

});





// WEBPACK FOOTER //
// ./assets/js/src/modules/lightbox.js